import { z } from "zod";
import { baseProfileSchema } from "@shared/schemas/sharedSchemas";
import { apiRequest } from "@shared/services/api/apiRequest";

export type Args = {
  data: z.infer<typeof baseProfileSchema>;
  role: string;
};

export async function updateUserProfile({ data, role }: Args) {
  const { firstName, lastName, isEmailNotificationsEnabled, ...rest } = data;

  // Check if we have any media uploads to include
  const payload = {
    first_name: firstName,
    last_name: lastName,
    is_email_notifications_enabled: isEmailNotificationsEnabled,
    role,
    ...rest,
  };

  console.log(payload);

  const response = await apiRequest(
    `/api/user/update-profile/`,
    "POST",
    payload
  );

  return response;
}
